/**
 * Fields step body for CreateObjectTypeWizard — wraps InlinePropertyEditor
 * and consumes wizard context for the disabled state. Extracted from
 * CreateObjectTypeWizard.tsx to keep that file within the project's
 * file-size convention.
 */

import { memo } from 'react';

import { useWizardContext } from '@/lib/base/wizard';

import {
  InlinePropertyEditor,
  type PropertyDefinition,
} from '../../InlinePropertyEditor';

export interface InlinePropertyEditorStepProps {
  properties: PropertyDefinition[];
  onPropertiesChange: (props: PropertyDefinition[]) => void;
}

function InlinePropertyEditorStepBodyImpl({
  properties,
  onPropertiesChange,
}: InlinePropertyEditorStepProps) {
  const { isSubmitting } = useWizardContext();
  return (
    <InlinePropertyEditor
      properties={properties}
      onChange={onPropertiesChange}
      disabled={isSubmitting}
    />
  );
}

export const InlinePropertyEditorStepBody = memo(
  InlinePropertyEditorStepBodyImpl
);
